import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_1hsvo6fo88: FaireBrandEntity = {
  token: "b_1hsvo6fo88",
  type: "brand",
  name: "Wishlist Apparel",
  avatarUrl:
    "https://cdn.faire.com/fastly/429b4e6b22494e9487b3f9b2d0a169b6f7c35fbf4983ec71db3d02765f4753c7.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/e690ecee7bbc0b00e07ea347e0ea78eda8908b54cf7d0b242cf8c2a249ec6cb8.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/429b4e6b22494e9487b3f9b2d0a169b6f7c35fbf4983ec71db3d02765f4753c7.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e690ecee7bbc0b00e07ea347e0ea78eda8908b54cf7d0b242cf8c2a249ec6cb8.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 0,
  rating: 4.9,
  reviewCount: 236,
  isTopShop: true,
  isInsider: true,
  description:
    "Wishlist Apparel is a women’s young contemporary wholesale brand that specializes in creating a twist on staple classics that can be worn all year round. We put a special emphasis on our quality, fit and like to stick with our unique color palette. Wishlist broke through with our bralettes and soon realized that the everyday woman was looking for a combination of both style and comfort. From bralettes to tops to dresses, we want the Wishlist woman to be confident, trendy, and overall comfortable.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:43:56.729Z",
    importedBy: "entity-db-cli",
  },
};
